import type { Bounds } from 'quill/core';

const translateBoundary = (
  boundary: Bounds,
  from: HTMLElement,
  to: HTMLElement,
): Bounds => {
  const containerRect: Bounds = to.getBoundingClientRect();
  const cellContainerRect: Bounds = from.getBoundingClientRect();
  return {
    left: boundary.left + cellContainerRect.left - containerRect.left,
    right: boundary.right + containerRect.right - cellContainerRect.right,
    width: boundary.width,
    top: boundary.top + cellContainerRect.top - containerRect.top,
    bottom: boundary.bottom + containerRect.bottom - cellContainerRect.bottom,
    height: boundary.height,
  };
};

export default translateBoundary;
